export const numberWithCommas = (x: number) => {
  return x ? x.toLocaleString("en") : "0";
};
